export const LOCALES = {
    EHGLISH: 'en',
    FRENCH: 'fr'
};